import {
  CircularProgress,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material';
import useAxiosPrivate from 'hooks/useAxiosPrivate';
import { memo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from 'react-query';
import { useSearchParams } from 'react-router-dom';

const GenericSelectFilter = ({
  query = 'query_name',
  label = 'label',
  idField = 'id',
  nameField = 'name',
  className,
  path = '/generic/path',
}) => {
  const { t } = useTranslation();
  const axiosPrivate = useAxiosPrivate();
  const [hasError, setHasError] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();

  const { data, isLoading, isFetching } = useQuery({
    queryKey: path,
    queryFn: async function () {
      const response = await axiosPrivate.get(path);
      return response.data.data;
    },
    enabled: !hasError,
    onError: (error) => {
      setHasError(true);
    },
    refetchOnMount: false,
    retry: false,
  });

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    searchParams.set(query, value);
    let localSearchParams = Object.fromEntries([...searchParams]);
    if (!isNaN(localSearchParams.page)) {
      searchParams.set('page', 1);
    }
    setSearchParams(searchParams);
  };

  const handleClearSelectBox = () => {
    searchParams.delete(query);
    setSearchParams(searchParams);
  };

  return (
    <FormControl className={className} fullWidth color='formColor'>
      <InputLabel id='single-block-filter-label'>{label}</InputLabel>
      <Select
        labelId='single-block-filter-label'
        id='single-block-filter-chip'
        label={t('common.fields.staffName')}
        value={searchParams.get(query) || ''}
        onChange={handleChange}
        className={className}
        color='formColor'
        variant='outlined'
        MenuProps={{
          id: 'single-block-filter-select-menu',
          PaperProps: {
            style: {
              maxHeight: 300,
            },
          },
          disableScrollLock: true,
        }}
        endAdornment={
          <InputAdornment position='end' className='custom-endAdornment'>
            {searchParams.get(query) && (
              <IconButton
                onClick={() => handleClearSelectBox()}
                variant='onlyIcon'
                className='select-box-end-adornment-button'
              >
                <i className='bi bi-x end-adornment-close-button' />
              </IconButton>
            )}
          </InputAdornment>
        }
      >
        {isLoading || isFetching ? (
          <div className='circular-progress-box'>
            <CircularProgress size={25} />
          </div>
        ) : data && data.length > 0 ? (
          data.map((item, index) => (
            <MenuItem value={`${item?.[idField]}`} key={`block-${index + 1}`}>
              {item?.[nameField]}
            </MenuItem>
          ))
        ) : (
          <div>
            <span className='no-data-found-wrapper select-box'>
              <i className='bi bi-exclamation-octagon text-lg mr-1' /> Ma'lumot
              topilmadi!
            </span>
          </div>
        )}
      </Select>
    </FormControl>
  );
};

export default memo(GenericSelectFilter);
